import axios from '@/http/axios'
import store from "../../store/store";
import {createCancelTokenHandler, makeQuery} from "../axios/utils";

const cancelTokenHandlerObject = {
  getProfileReceivedEvents: createCancelTokenHandler('getProfileReceivedEvents'),
  getProfileReceivedEventsNavbar: createCancelTokenHandler('getProfileReceivedEventsNavbar'),
  getProfileSentEvents: createCancelTokenHandler('getProfileSentEvents')
}

/* Profile */
export function getProfile () {
  return axios({
    url: 'v1/portal/profile',
    method: 'get'
  })
}

export function editProfile (payment) {
  return axios.patch('v1/portal/profile', payment)
}

export function getProfileReceivedEvents (page, filters = {}, sorts = [], navbar = false) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/portal/profile/received-events${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject[`getProfileReceivedEvents${navbar ? 'Navbar' : ''}`].handleRequestCancellation().token
  })
}

export function getProfileSentEvents (page, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/portal/profile/sent-events${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject['getProfileSentEvents'].handleRequestCancellation().token
  })
}

export function getProfileAddresses (page, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/portal/profile/addresses${queries}`,
    method: 'get'
  })
}

export function insertProfileAddress (payload) {

  return axios({
    url: 'v1/portal/profile/addresses',
    data: payload,
    method: 'post'
  })
}

export function editProfileAddress (id, payment) {
  return axios.patch(`v1/portal/profile/addresses/${id}`, payment)
}

export function deleteProfileAddress (id) {
  return axios({
    url: `v1/portal/profile/addresses/${id}`,
    method: 'delete'
  })
}

export function editProfileBrowserSettings (payload = {}) {
  const browser = JSON.parse(store.state.auth.user.browser_setting)
  let setting = {
    ...payload,
    tables: store.state.table.tables,
    // tables: {},
    // tables: store.state.table.tables.storesListTable ? store.state.table.tables.storesListTable : [],
    theme: store.state.theme,
    sidebarCollapsed: store.state.reduceButton
  }
  if (!setting.hasOwnProperty('mainChart') && browser && browser.hasOwnProperty('mainChart')) {
    const mainChart = browser.mainChart
    if (browser.hasOwnProperty('mainChart')) {
      setting.mainChart = mainChart
    }
  }
  delete setting.tables.tables
  delete setting.tables.theme
  store.dispatch('auth/updateUserInfo', {browser_setting: JSON.stringify(setting) })
  // console.log(JSON.stringify(setting))
  // console.log(setting)
  return axios.patch('v1/portal/profile/browser-settings?loading=false', { settings: JSON.stringify(setting) })
}

export function getProfileActiveSessions () {
  return axios({
    url: 'v1/portal/profile/active-sessions',
    method: 'get'
  })
}

export function revokeActiveSession (id) {
  return axios({
    url: `v1/portal/profile/active-sessions/${id}`,
    method: 'delete'
  })
}

export function sendPushNotification (payload) {

  return axios("/v1/portal/profile/push-subscription", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: payload
  })
}
